// @ts-nocheck -- generated SVG assets; dynamic values are supplied by callers.
import { SvgIcon } from "../SvgIcon";

export function SvgAsset1(_props: any) {
  return (
    <SvgIcon width="22" height="22" viewBox="0 0 24 24" fill="none">
      <path
        d="M12 16V4m0 0L7 9m5-5l5 5"
        stroke="#fff"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M4 15v3a2 2 0 002 2h12a2 2 0 002-2v-3"
        stroke="#fff"
        strokeWidth="2.2"
        strokeLinecap="round"
      ></path>
    </SvgIcon>
  );
}

export function SvgAsset2(_props: any) {
  return (
    <SvgIcon width="14" height="14" viewBox="0 0 24 24" fill="none">
      <path
        d="M5 12h14M13 6l6 6-6 6"
        stroke="#4F46E5"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </SvgIcon>
  );
}

export function SvgAsset3(_props: any) {
  return (
    <SvgIcon width="22" height="22" viewBox="0 0 24 24" fill="none">
      <path
        d="M4 7h7M4 12h7M4 17h5"
        stroke="#fff"
        strokeWidth="2.2"
        strokeLinecap="round"
      ></path>
      <path
        d="M15 9l3 3-3 3M20 12h-8"
        stroke="#fff"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </SvgIcon>
  );
}

export function SvgAsset4(_props: any) {
  return (
    <SvgIcon width="14" height="14" viewBox="0 0 24 24" fill="none">
      <path
        d="M5 12h14M13 6l6 6-6 6"
        stroke="#7A4DF0"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </SvgIcon>
  );
}

export function SvgAsset5(_props: any) {
  return (
    <SvgIcon width="22" height="22" viewBox="0 0 24 24" fill="none">
      <path
        d="M12 2l2.6 6.3L21 10l-5 4.2L17.4 21 12 17.4 6.6 21 8 14.2 3 10l6.4-1.7z"
        fill="#fff"
      ></path>
    </SvgIcon>
  );
}

export function SvgAsset6(_props: any) {
  return (
    <SvgIcon width="14" height="14" viewBox="0 0 24 24" fill="none">
      <path
        d="M5 12h14M13 6l6 6-6 6"
        stroke="#0FA968"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </SvgIcon>
  );
}

export function SvgAsset7(_props: any) {
  return (
    <SvgIcon width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        d="M12 16V4m0 0L7 9m5-5l5 5"
        stroke="#4F46E5"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M4 15v3a2 2 0 002 2h12a2 2 0 002-2v-3"
        stroke="#4F46E5"
        strokeWidth="2.2"
        strokeLinecap="round"
      ></path>
    </SvgIcon>
  );
}

export function SvgAsset8(_props: any) {
  return (
    <SvgIcon width="15" height="15" viewBox="0 0 24 24" fill="none">
      <path
        d="M12 2l2.6 6.3L21 10l-5 4.2L17.4 21 12 17.4 6.6 21 8 14.2 3 10l6.4-1.7z"
        fill="#fff"
      ></path>
    </SvgIcon>
  );
}

export function SvgAsset9(_props: any) {
  return (
    <SvgIcon width="15" height="15" viewBox="0 0 24 24" fill="none">
      <path
        d="M6 2h9l5 5v15H6z"
        stroke="#fff"
        strokeWidth="2"
        strokeLinejoin="round"
      ></path>
    </SvgIcon>
  );
}

export function SvgAsset10(_props: any) {
  return (
    <SvgIcon width="15" height="15" viewBox="0 0 24 24" fill="none">
      <path d="M13 2L4 14h7l-1 8 9-12h-7z" fill="#fff"></path>
    </SvgIcon>
  );
}

export function SvgAsset11(_props: any) {
  return (
    <SvgIcon width="18" height="18" viewBox="0 0 24 24" fill="none">
      <path
        d="M12 2l2.6 6.3L21 10l-5 4.2L17.4 21 12 17.4 6.6 21 8 14.2 3 10l6.4-1.7z"
        fill="#fff"
      ></path>
    </SvgIcon>
  );
}

export function SvgAsset12(_props: any) {
  return (
    <SvgIcon width="14" height="14" viewBox="0 0 24 24" fill="none">
      <path
        d="M6 2h9l5 5v15H6z"
        stroke="#0FA968"
        strokeWidth="2"
        strokeLinejoin="round"
      ></path>
    </SvgIcon>
  );
}

export function SvgAsset13(_props: any) {
  return (
    <SvgIcon width="17" height="17" viewBox="0 0 24 24" fill="none">
      <path
        d="M5 13l4 4L19 7"
        stroke="#fff"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </SvgIcon>
  );
}

export function SvgAsset14(_props: any) {
  return (
    <SvgIcon width="16" height="16" viewBox="0 0 24 24" fill="none">
      <path
        d="M5 12h14M13 6l6 6-6 6"
        stroke="#fff"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </SvgIcon>
  );
}

export function SvgAsset15(_props: any) {
  return (
    <SvgIcon width="26" height="26" viewBox="0 0 24 24" fill="none">
      <path
        d="M5 13l4 4L19 7"
        stroke="#fff"
        strokeWidth="3.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </SvgIcon>
  );
}

export function SvgAsset16(_props: any) {
  return (
    <SvgIcon width="17" height="17" viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="8" r="4" stroke="#7A4DF0" strokeWidth="2"></circle>
      <path
        d="M4 20a8 8 0 0116 0"
        stroke="#7A4DF0"
        strokeWidth="2"
        strokeLinecap="round"
      ></path>
    </SvgIcon>
  );
}

export function SvgAsset17(_props: any) {
  return (
    <SvgIcon width="17" height="17" viewBox="0 0 24 24" fill="none">
      <circle cx="9" cy="8" r="3.2" stroke="#0FA968" strokeWidth="2"></circle>
      <circle cx="17" cy="9" r="2.6" stroke="#0FA968" strokeWidth="2"></circle>
      <path
        d="M3 20a6 6 0 0112 0M15 20a6 6 0 016-3"
        stroke="#0FA968"
        strokeWidth="2"
        strokeLinecap="round"
      ></path>
    </SvgIcon>
  );
}

export function SvgAsset18(_props: any) {
  return (
    <SvgIcon width="17" height="17" viewBox="0 0 24 24" fill="none">
      <path
        d="M8 7h8M8 11h8M10 4v3m4-3v3M7 4h10a0 0 0 010 0v13a3 3 0 01-3 3h-4a3 3 0 01-3-3V4z"
        stroke="#E8730C"
        strokeWidth="1.8"
        strokeLinecap="round"
      ></path>
    </SvgIcon>
  );
}

export function SvgAsset19(_props: any) {
  return (
    <SvgIcon width="17" height="17" viewBox="0 0 24 24" fill="none">
      <path
        d="M12 2l2.6 6.3L21 10l-5 4.2L17.4 21 12 17.4 6.6 21 8 14.2 3 10l6.4-1.7z"
        fill="#fff"
      ></path>
    </SvgIcon>
  );
}

export function SvgAsset20(_props: any) {
  return (
    <SvgIcon width="16" height="16" viewBox="0 0 24 24" fill="none">
      <path
        d="M5 12h14M13 6l6 6-6 6"
        stroke="#fff"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </SvgIcon>
  );
}

export function SvgAsset21(_props: any) {
  return (
    <SvgIcon width="28" height="28" viewBox="0 0 24 24" fill="none">
      <path
        d="M12 2l2.6 6.3L21 10l-5 4.2L17.4 21 12 17.4 6.6 21 8 14.2 3 10l6.4-1.7z"
        fill="#fff"
      ></path>
    </SvgIcon>
  );
}

export function SvgAsset22(_props: any) {
  return (
    <SvgIcon width="17" height="17" viewBox="0 0 24 24" fill="none">
      <path
        d="M5 12h14M13 6l6 6-6 6"
        stroke="#fff"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </SvgIcon>
  );
}

export function SvgAsset23(_props: any) {
  return (
    <SvgIcon width="14" height="14" viewBox="0 0 24 24" fill="none">
      <path
        d="M5 13l4 4L19 7"
        stroke="#fff"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </SvgIcon>
  );
}

export function SvgAsset24(_props: any) {
  return (
    <SvgIcon width="26" height="26" viewBox="0 0 24 24" fill="none">
      <path
        d="M5 13l4 4L19 7"
        stroke="#fff"
        strokeWidth="3.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </SvgIcon>
  );
}
